<template>
  <div>
    <div v-if="loading" class="text-center">
      <v-progress-circular size="200" indeterminate color="secondary"></v-progress-circular>
      <div class="text-center text-h6">
        Checking Permissions...
      </div>
    </div>
    <v-card flat v-else-if="isAdmin">
      <v-card-title>
        Created for Ground Standard
      </v-card-title>
      <v-card-text v-if="today">
        <div>
          <div class="text-subtitle-1">From: </div>
          <DatePicker :locale="$i18n.locale" :max="today" v-model="from">
          </DatePicker>
        </div>
        <div>
          <div class="text-subtitle-1">To: </div>
          <DatePicker :locale="$i18n.locale" :max="today" v-model="to">
          </DatePicker>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn outlined elevation="0" color="primary" @click="getData()">Get Data</v-btn>
      </v-card-actions>
    </v-card>
    <v-card flat v-else>
      <v-card-text class="text-center text-h2">Not Allowed</v-card-text>
      <v-card-text class="text-center">
        <v-icon size="200" color="error">mdi-hand-back-left-outline</v-icon>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Api from "@/services/Api";
import DatePicker from "@/components/inputs/DateTimePicker.vue";

export default {
  data() {
    return {
      loading: true,
      partner: 'Ground Standard',
      today: null,
      from: null,
      to: null,
      isAdmin: false,
    };
  },
  components: {
    DatePicker
  },
  created() {
    this.isAllowed();
    const today = new Date();
    const from = new Date();
    from.setHours(0);
    const to = new Date();
    to.setDate(to.getDate() + 1)
    from.setMonth(from.getMonth() - 1);
    this.from = from;
    this.to = to;
    this.today = today;
  },
  methods: {
    isAllowed() {
      if (this.isAppAdmin()) {
        this.loading = false;
        this.isAdmin = true;
      } else {
        Api()
          .post(
            "partners/managedacademy/" +
            this.$store.state.managedAcademy +
            "/get/admins", { partner: this.partner }
          )
          .then((response) => {
            if (response.data.allowed) this.isAdmin = true;
            this.loading = false;
          }).catch(() => {
            this.loading = false;
          });
      }
    },
    getData() {
      let data = {
        from: this.from,
        to: this.to,
        partner: this.partner,
        report: 'get-member-activity-data',
      };
      Api()
        .post(
          "partners/managedacademy/" +
          this.$store.state.managedAcademy +
          "/get/data", data
        )
        .then((response) => {
          const email = response.data.email;
          this.showAlert("success", "Check your [" + email + "] email in a bit.");
        });
    }
  }
}
</script>

<style scoped></style>